<template>
  <span>
    <a-rate v-model="outputRating[0]" disabled />
    <span class="ant-rate-text">{{ratingStatus}}</span>
  </span>
</template>

<script>
export default {
  name: "Rating",
  props: {
    rating: {
      type: String
    }
  },
  data() {
    return {
      ratingStatus: ""
    };
  },
  computed: {
    outputRating() {
      let rateIn = parseInt(this.rating, 10);

      if (rateIn >= 12) {
        rateIn = 5;
        this.ratingStatus = "Excelent";
      } else if (rateIn < 12 && rateIn >= 9) {
        rateIn = 4;
        this.ratingStatus = "Good";
      } else if (rateIn < 9 && rateIn >= 6) {
        rateIn = 3;
        this.ratingStatus = "Fair";
      } else if (rateIn < 6 && rateIn >= 3) {
        rateIn = 2;
        this.ratingStatus = "Poor";
      } else if (rateIn < 3 || isNaN(rateIn)) {
        rateIn = 1;
        this.ratingStatus = "Bad";
      }

      return [rateIn, this.ratingStatus];
    }
  }
};
</script>

<style>
</style>